import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";
import { Eye, EyeOff, CheckCircle2 } from "lucide-react";

export default function PartnerReset() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { login } = useApp();
  const token = sp.get("t") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (password.length < 8) return toast.error("Mínimo 8 caracteres");
    if (password !== confirm) return toast.error("Las contraseñas no coinciden");
    try {
      const r = await api.post("/partner/password/reset", { token, password });
      login(r.data.token, "partner", { email: r.data.email, code: r.data.code });
      setDone(true);
      setTimeout(() => nav("/socio/panel"), 1200);
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  if (!token) return <div className="max-w-md mx-auto p-8 text-center text-slate-500">Enlace inválido</div>;

  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <Card><CardContent className="p-6 sm:p-8">
        {done ? (
          <div className="text-center py-4">
            <CheckCircle2 size={48} className="text-emerald-600 mx-auto mb-2"/>
            <p data-testid="partner-reset-success" className="text-sm text-slate-700">Contraseña actualizada. Redirigiendo…</p>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-slate-900 mb-1">Nueva contraseña</h1>
            <p className="text-sm text-slate-500 mb-5">Elige una nueva contraseña para tu cuenta Socio referidor.</p>
            <div className="space-y-3">
              <div><Label>Nueva contraseña</Label>
                <div className="relative">
                  <Input data-testid="reset-pw-input" type={showPw ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)}/>
                  <button type="button" data-testid="toggle-pw" onClick={() => setShowPw(!showPw)}
                          className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700">
                    {showPw ? <EyeOff size={16}/> : <Eye size={16}/>}
                  </button>
                </div>
                <p className="text-[11px] text-slate-500 mt-1">Mínimo 8 caracteres</p>
              </div>
              <div><Label>Confirmar</Label>
                <Input data-testid="reset-pw-confirm" type={showPw ? "text" : "password"} value={confirm} onChange={e => setConfirm(e.target.value)}/></div>
            </div>
            <Button data-testid="reset-submit-btn" onClick={submit} className="w-full mt-5 bg-blue-600 hover:bg-blue-700">
              Guardar
            </Button>
          </>
        )}
      </CardContent></Card>
    </div>
  );
}
